import { styled } from '@linaria/react';

const SelectContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const SelectLabel = styled.div`
  color: #666;
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  line-height: 0px;
`;

export { SelectContainer, SelectLabel };
